module.exports = __webpack_public_path__ + "img/credi_centro.a7d93028.png";